import { NUMBERS_REG_EXP } from '@/shared/const';

export const formatDateSymbols = (date: string) => {
    const numbers = date.split('').filter((el) => NUMBERS_REG_EXP.test(el));

    const [y1, y2, y3, y4, m1, m2, d1, d2] = numbers;

    return `${d1}${d2}.${m1}${m2}.${y1}${y2}${y3}${y4}`;
};
